import React from 'react';

// The three filters every metrics view shares. They are reporting dimensions,
// not drill-downs: narrowing by semester or date changes which episodes are
// scored, and the server re-applies the privacy floor to whatever is left. A
// filter can therefore make a metric disappear, which is the intended
// behaviour, not a bug.
const MetricsFilters = ({ filters, onChange, maxSequence = 6 }) => {
  const set = (key) => (event) =>
    onChange({ ...filters, [key]: event.target.value || '' });

  const field = 'rounded-md border border-slate-300 bg-white px-2 py-1 text-sm text-slate-700';

  return (
    <div className="flex flex-wrap items-end gap-4">
      <label className="flex flex-col gap-1">
        <span className="text-xs font-medium text-slate-500">Compared against</span>
        <select
          className={field}
          value={filters.comparison || 'from_intake'}
          onChange={set('comparison')}
        >
          <option value="from_intake">Intake (cumulative)</option>
          <option value="from_previous">Previous semester</option>
        </select>
      </label>

      <label className="flex flex-col gap-1">
        <span className="text-xs font-medium text-slate-500">Semester number</span>
        <select className={field} value={filters.sequence || ''} onChange={set('sequence')}>
          <option value="">All semesters</option>
          {Array.from({ length: maxSequence }, (unused, index) => index + 1).map((n) => (
            <option key={n} value={n}>
              Semester {n}
            </option>
          ))}
        </select>
      </label>

      <label className="flex flex-col gap-1">
        <span className="text-xs font-medium text-slate-500">Outcomes on or after</span>
        <input
          type="date"
          className={field}
          value={filters.since || ''}
          onChange={set('since')}
        />
      </label>

      {(filters.sequence || filters.since || filters.comparison === 'from_previous') && (
        <button
          type="button"
          onClick={() => onChange({ comparison: 'from_intake', sequence: '', since: '' })}
          className="pb-1 text-sm font-medium text-blue-600 hover:text-blue-500"
        >
          Reset
        </button>
      )}
    </div>
  );
};

export default MetricsFilters;
